import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Model, Trim } from '../../shared/models/series-data';
import { Store } from '@ngrx/store';
import { Observable, Subject, Subscription } from 'rxjs';
import { SalesAppointmentState } from '../../store/sales-appointment/sales-appointment.reducer';
import * as fromActions from '../../store/sales-appointment/sales-appointment.actions';
import * as fromSelectors from '../../store/sales-appointment/sales-appointment.selectors';
import { confirmConfig } from '../../shared/services/util.service';
import _ from 'lodash';
import { filter, take } from 'rxjs/operators';
import { ICustomer, IAvailabilityOptions, IAvailability, AppointmentType,IGeneralSettingsAppointmentRequest } from '@signal/asp-data-commons';
import { ITransportOption } from '@signal/asp-data-commons/lib/interfaces/general-setttings';
import { DateTime } from 'luxon';
import { SearchCustomersState } from '../../store/search-customers/search-customers.reducer';
import { selectCurrentCustomer } from '../../store/search-customers/search-customers.selectors';
import { AspBannerService } from '../../shared/services/asp-banner.service';
import { SettingsState } from '../../store/settings/settings.reducer';
import { LoadSettings } from '../../store/settings/settings.actions';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AvailabilityComponent } from '../../shared/components/availability/availability.component';
import * as fromSettingsSelectors from "../../store/settings/settings.selectors";
import { CustomerType } from '../../shared/enums/customer-types.enum';

@Component({
  selector: 'app-inquiry-appointment',
  templateUrl: './inquiry-appointment.component.html',
  styleUrls: ['./inquiry-appointment.component.scss']
})
export class InquiryAppointmentComponent implements OnInit, OnDestroy {
  inquiryForm: UntypedFormGroup;
  signedIn: boolean;
  appointmentId: string;
  isSubmitting: boolean;
  isUpdate = false;
  isStoreUpdate = false;
  isValidRemoteZip = false;
  hasRemoteLocation = false;
  transport;
  validatedFields = ['year', 'model', 'trim'];
  otherVehicleChecked = false;
  isCustomerPanelExpanded = false;
  previousZip = '';
  apptType: string = AppointmentType.VEHICLE_INQUIRY;
  firstTimeAvailabilityLoaded = false;

  @ViewChild(AvailabilityComponent, { static: false }) AvailabilityComponent: AvailabilityComponent;

  /* All 4 steps are sub form - Accessible only through the main form */
  inquiryVehicle: UntypedFormControl;
  otherVehiclesForm: UntypedFormArray;
  tradeInForm: UntypedFormControl;
  availability: UntypedFormControl;
  customerForm: UntypedFormControl;
  contactEmailInfoForm: UntypedFormControl;

  availabilityOptions$: Observable<IAvailabilityOptions>;
  availabilityOptionsLoading$: Observable<boolean>;
  availability$: Observable<IAvailability>;
  availabilityLoading$: Observable<boolean>;
  transportOptions$: Observable<ITransportOption[]>;
  remoteZipcodes$: Observable<string[]>;
  yearList$: Observable<number[]>;
  modelList$: Array<Observable<Model[]>> = [];
  trimList$: Array<Observable<Trim[]>> = [];
  customerDetails$: Observable<ICustomer>;
  remoteValidZipcodes: { pmaZipCodes: string[], isRemote: boolean };
  subscriptions: Subscription[] = [];
  dateFormat = 'yyyy-MM-dd';

  lastValue: any;
  private storeValue: any;
  private signedInUserDetails: ICustomer;

  valueChanged = true;
  showMandatoryMsgCI:boolean = false;
  aptType: string = AppointmentType.VEHICLE_INQUIRY;
  load = false;
  isVinValid = false;
  loadingAvailability = false;

  languageId = '';
  customerDataOnEdit;
  settings:IGeneralSettingsAppointmentRequest={} as IGeneralSettingsAppointmentRequest;

  constructor(
    private readonly dialog: MatDialog,
    private readonly viewportScroller: ViewportScroller,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly salesAppointmentState: Store<SalesAppointmentState>,
    private readonly searchCustomersState: Store<SearchCustomersState>,
    private readonly settingsState: Store<SettingsState>,
    private readonly bannerService: AspBannerService,
    private readonly translateService: TranslateService,
    private readonly cd: ChangeDetectorRef) {
    this.apptType = AppointmentType.VEHICLE_INQUIRY;
    this.initializeinquiryForm();
    this.settingsState.dispatch(new LoadSettings({ department: 'sales' }));
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      if (params && params.id) {
        this.appointmentId = params.id;
        if (this.appointmentId) {
          this.salesAppointmentState.dispatch(new fromActions.GetEditData
            ({ appointmentType: AppointmentType.VEHICLE_INQUIRY, appointmentId: this.appointmentId }));
          this.isUpdate = true
        }
      }
    })
    )
  }
  canExit(): Observable<boolean> {
    const result = new Subject<boolean>();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, confirmConfig);
    this.subscriptions.push(dialogRef.afterClosed().subscribe(event => {
      /* * if (event.action === 'confirm') { } */
      if (event.action === 'close') {
        result.next(true);
        result.complete();
      }
    })
    )
    return result.asObservable();
  };

  // returns if the forms are edited
  formsNotEdited() {
    return this.valueChanged;
  }

  formValuesChanges(event) {
    this.valueChanged = event;
  }

  isCIformValid(event) {
    this.showMandatoryMsgCI = event;
  }

  ngAfterContentChecked(): void {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

  ngOnInit() {
    this.previousZip = '';
    this.viewportScroller.scrollToPosition([0, 0]);
    this.bannerService.update('');
    this.bannerService.show();
    this.setupStoreValue();
  }

  initializeinquiryForm() {
    this.initializeOtherVehicleForm();

    /* Initialize main form group with sub forms */
    this.inquiryForm = this.formBuilder.group({
      inquiryVehicle: this.inquiryVehicle,
      otherVehicles: this.otherVehiclesForm,
      tradeIn: this.tradeInForm,
      transportationTypeCode: ['', [Validators.required]],
      remoteZipCode: [''],
      availability: this.availability,
      customer: this.contactEmailInfoForm,
      address: this.customerForm
    });
    this.inquiryForm.controls.remoteZipCode.setValidators(this.zipValidator());
    this.inquiryForm.controls['inquiryVehicle'].setValidators([]);
    this.onValueChange();
  }

  initializeOtherVehicleForm() {
    this.otherVehiclesForm = new UntypedFormArray([new UntypedFormGroup({
      year: new UntypedFormControl(''),
      model: new UntypedFormControl(''),
      trim: new UntypedFormControl('')
    })]);
  }

  zipValidator(): ValidatorFn {
    return (_control: UntypedFormControl): ValidationErrors => {
      this.transport = this.inquiryForm.value.transportationTypeCode;
      if (this.inquiryForm.value.transportationTypeCode === 'REMOTE' && !this.isValidRemoteZip) {
        return { remoteZipCode: this.translateService.instant('service.invalidRemoteZipcode') };
      } else {
        return null;
      }
    };
  }


  setSignedInUserDetails() {
    this.customerDetails$ = this.searchCustomersState.select(selectCurrentCustomer);
    this.subscriptions.push(this.customerDetails$
      .subscribe(customer => {
        this.signedInUserDetails = {
          firstName: customer?.firstName || '',
          lastName: customer?.lastName || '',
          emailAddress: !customer?.drvaFlag ? customer?.emailAddress : '',
          phoneNumber: !customer?.drvaFlag ? customer?.phoneNumber : ' ',
          customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
          businessName: customer?.businessName || '',
          drvaFlag: customer?.drvaFlag || false
       //   customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
      //    businessName: customer?.businessName || ''
        };
        this.salesAppointmentState.dispatch(new fromActions.LoadCustomerDetails({ signedInUserDetails: this.signedInUserDetails }));
      })
    )
  }

  checkZipCodes(value) {
    this.inquiryForm.controls.remoteZipCode.clearValidators();
    if (this.inquiryForm.value.transportationTypeCode === 'REMOTE') {
      this.subscriptions.push(this.remoteZipcodes$.pipe(
        filter(zip => !!zip?.length),
        take(1)).subscribe(zip => {
          this.remoteValidZipcodes = { pmaZipCodes: zip, isRemote: true };
          this.isValidRemoteZip = zip?.findIndex(x => x === value) !== -1;
          this.inquiryForm.controls.remoteZipCode.setValidators(this.zipValidator());
          this.inquiryForm.controls.remoteZipCode.updateValueAndValidity();

        }))
    }
  }

  setupStoreValue() {
    this.setSignedInUserDetails();
    this.salesAppointmentState.dispatch(new fromActions.LoadAvailabilityOptions({ appointmentType: AppointmentType.VEHICLE_INQUIRY }));
    this.availabilityOptions$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityOptions);
    this.availabilityOptionsLoading$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityOptionsLoading);
    this.availability$ = this.salesAppointmentState.select(fromSelectors.getAvailability);
    this.availabilityLoading$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityLoading);
    this.transportOptions$ = this.salesAppointmentState.select(fromSelectors.getTransportOptions);
    this.remoteZipcodes$ = this.salesAppointmentState.select(fromSelectors.getPMAZipCodes);
    this.yearList$ = this.salesAppointmentState.select(fromSelectors.getYearList);

    this.subscriptions.push(this.availabilityOptions$.subscribe(_options => {
      /** this.hasRemoteLocation = !!options?.transport?.transportOptions?.find(x => x.category === LocationType.REMOTE && x.isActive && x.enableTestDriveType); */ 
      this.hasRemoteLocation = false;
    })
    )

    this.subscriptions.push(this.settingsState.select(fromSettingsSelectors.selectSettings).subscribe(settings => {
      if(settings && Object.entries(settings).length)
      {
        this.settings.time=settings.time;
        this.settings.portal=settings.portal;
        this.settings.dealerInfo=settings.dealerInfo;
        this.settings.isAspCrmIntegrationEnabled=settings.isAspCrmIntegrationEnabled;
        this.settings.isAspDmsIntegrationEnabled=settings.isAspDmsIntegrationEnabled;
        this.settings.isConsumerPortalEnabled=settings.isConsumerPortalEnabled;
        this.settings.isServiceAccessible=settings.isServiceAccessible;
      }
    }));

    this.subscriptions.push(this.salesAppointmentState.select(fromSelectors.inquiryAppointmentDetails).subscribe((data) => {
      const value = { ...data };
      delete value.appointmentStatus;
      delete value.checklistRequest;

      if (_.isEqual(this.lastValue, value)) {
        return;
      }

      this.languageId = value?.availability?.languageId;
      this.lastValue = value;
      this.isStoreUpdate = true;

      /*isUpdate -> During edit mode we need to store the state value thats coming in,
       so that we can check the incoming form changes against storeValue
       isStoreUpdate -> Phase 2 (basically used when changes are invoked from state during create mode)*/
      if (this.isUpdate || this.isStoreUpdate) {
        this.storeValue = { ...value };
        this.customerDataOnEdit = value.customer;
      }
      this.inquiryForm.patchValue(value);
      this.checkZipCodes(value.remoteZipCode);
      this.setOtherVehicles(value);

    })
    )
    this.subscriptions.push(this.searchCustomersState.select(selectCurrentCustomer)
      .subscribe(customer => {
        this.isCustomerPanelExpanded = !customer;
      })
    )
  }

  setOtherVehicles(data) {
    if (this.isUpdate && data.otherVehicles) {
      this.otherVehicleChecked = data.otherVehicles[0] && !!data.otherVehicles[0].year;
      data.otherVehicles.forEach((element, i) => {
        if (!this.otherVehiclesArray.controls[i]) {
          this.otherVehiclesArray.push(new UntypedFormGroup({
            year: new UntypedFormControl(element.year),
            model: new UntypedFormControl(element.model),
            trim: new UntypedFormControl(element.trim)
          }));
        } else {
          this.otherVehiclesArray.controls[i].patchValue(new UntypedFormGroup({
            year: new UntypedFormControl(element.year),
            model: new UntypedFormControl(element.model),
            trim: new UntypedFormControl(element.trim)
          }));
        }
        this.otherVehiclesArray.controls[i].setValidators(this.setOtherVehicleValidator());
      });
    }
  }
  onValueChange() {
    this.subscriptions.push(this.inquiryForm.valueChanges.subscribe(value => {
      this.setObservablesForOtherVehicles(value);

      const val = _.cloneDeep(value);

      /*Updating storeValue = undefined everytime the form is updated to the initial changes from the state */
      if (this.storeValue && _.isEqual(this.storeValue, val)) {
        this.storeValue = undefined;
        this.isStoreUpdate = false;
        if (this.isUpdate && !this.storeValue) {
          return
        }
        /* for the very first time lastValue, storeValue and value will be equal,
         hence the storeValue will be undefined. To handle this scenario we are
         reassigning the same value from the store*/
        if (_.isEqual(this.lastValue, value)) {
          this.storeValue = this.lastValue;
        }
        return;
      }

      if (_.isEqual(this.lastValue, value)) {
        return;
      }

      if ((value.transportationTypeCode && this.lastValue.transportationTypeCode !== value.transportationTypeCode) || (value.availability?.advisorId && this.lastValue.availability?.advisorId !== value.availability.advisorId) && !this.firstTimeAvailabilityLoaded) {
        this.isStoreUpdate = true;
        this.firstTimeAvailabilityLoaded = true;
        /* *vin is available then only call the availability*/
        this.loadingAvailability = false;
        const chosenDate = value.availability.appointmentStartDate;
        if (chosenDate) {
          const date = DateTime.fromISO(chosenDate)
            .startOf('month')
            .toFormat('yyyy-MM-dd');
          this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
            {
              selectDateAndSlot: true, date, advisorId: value.availability.advisorId,
              transport: value.transportationTypeCode, appointmentType: AppointmentType.VEHICLE_INQUIRY,appointmentId:this.appointmentId ? this.appointmentId : ''
            }));
        } else {
          this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
            {
              selectDateAndSlot: false, date: '', advisorId: value.availability.advisorId,
              transport: value.transportationTypeCode,
              appointmentType: AppointmentType.VEHICLE_INQUIRY,appointmentId:this.appointmentId ? this.appointmentId : ''
            }));
        }
        this.availabilityLoading$.subscribe(value => {
          if (!value) {
            this.loadingAvailability = true;
          }
        })
        if (this.lastValue.transportationTypeCode !== value.transportationTypeCode) {
          this.salesAppointmentState.dispatch(new fromActions.LoadAvailabilityOptions({ appointmentType: AppointmentType.VEHICLE_INQUIRY }));
        }

      } else {
        this.isStoreUpdate = false;
      }

      /*lastValue keeps changing everytime the form value changes
       (even when the changes are from the initialstate or EditState) */
      this.lastValue = value;

      if (value?.customer?.emailAddress) {
        value.customer.emailAddress = value.customer.emailAddress.trim();
      }
      
      /*dispatch happens only when the storeValue = undefined which means
      that all the initial changes (initialState and EditState) from store are
      populated in the form and now we are dispatching the changes done by the user*/
      if (!this.storeValue) {
        this.salesAppointmentState.dispatch(new fromActions.UpdateSalesFormData({ value }));
      }
    })
    )

  }

  setObservablesForOtherVehicles(value) {
    if (value.otherVehicles.length && this.lastValue) {
      value.otherVehicles.forEach((_element, i) => {

        // reset dropdown values of model and trim if the year is changed
        if (this.lastValue.otherVehicles[i] && value.otherVehicles[i].year !== this.lastValue.otherVehicles[i].year) {
          this.modelList$.splice(i, 1);
          this.trimList$.splice(i, 1);
        }

        // reset dropdown values of trim if the model is changed
        if (this.lastValue.otherVehicles[i] && value.otherVehicles[i].model !== this.lastValue.otherVehicles[i].model) {
          this.trimList$.splice(i, 1);
        }

        // adding observables to the array only when 'Add Vehicle' is clicked
        if (i === this.modelList$.length && value.otherVehicles[i].year && this.modelList$.length !== value.otherVehicles.length) {
          this.modelList$.push(this.salesAppointmentState.select(fromSelectors.getOtherVehiclesSeriesList({ year: value.otherVehicles[i]?.year })));
        }

        if (i === this.trimList$.length && value.otherVehicles[i].year &&
          value.otherVehicles[i].model && this.trimList$.length !== value.otherVehicles.length) {
          this.trimList$.push(this.salesAppointmentState.select(fromSelectors.getOtherVehiclesTrimList,
            { model: value.otherVehicles[i]?.model, year: value.otherVehicles[i]?.year }));
        }
      });
    }
  }

  get otherVehiclesArray() {
    return this.inquiryForm.get('otherVehicles') as UntypedFormArray;
  }

  onAddVehicle() {
    this.otherVehiclesArray.push(new UntypedFormGroup({
      year: new UntypedFormControl(''),
      model: new UntypedFormControl(''),
      trim: new UntypedFormControl('')
    }));
    const index = this.otherVehiclesArray.length - 1;
    (this.otherVehiclesArray.controls[index] as UntypedFormGroup).setValidators(this.setOtherVehicleValidator());
  }

  onDeleteVehicle(index: number) {
    this.otherVehiclesArray.removeAt(index);
    this.modelList$.splice(index, 1);
    this.trimList$.splice(index, 1);
  }

  checkCustomerForm() {
    const customer = this.inquiryForm.controls.customer.value;
    const hasValidCustomerName = (customer?.customerType !== CustomerType.BUSINESS
      && customer?.firstName?.length > 0
      && customer?.lastName?.length > 0)
      || (customer?.customerType === CustomerType.BUSINESS
      && customer?.businessName?.length > 0);

    return this.inquiryForm.controls.address.value
      && hasValidCustomerName
      && this.checkIfEmailOrPhoneValid();
  }

  checkIfEmailOrPhoneValid() {
    /* check if email or phone entered */
    if (this.inquiryForm.controls.customer.value.emailAddress || this.inquiryForm.controls.customer.value.phoneNumber) {
      return this.inquiryForm.controls['customer'].valid;
    }

    /*return false if none is entered,either has to be entered*/
    return false;
  }


  checkIfAvaiabilityValid() {
    return this.AvailabilityComponent?.timeSlots?.filter(slot => slot?.timeSlotId === this.AvailabilityComponent?.oldValue?.timeSlotId)[0].isOpen
  }

  isValidTestdriveFrom() {
    return (this.inquiryForm.controls.availability.valid &&
      this.checkIfAvaiabilityValid() &&
      this.loadingAvailability &&
      this.inquiryForm.controls.transportationTypeCode.valid &&
      this.inquiryForm.controls.address.valid &&
      this.inquiryForm.controls.tradeIn.valid &&
      this.inquiryForm.controls.otherVehicles.valid &&
      this.inquiryForm.controls.remoteZipCode.valid && this.checkCustomerForm());
  }

  isValidForm() {
    const apptStartDate = this.inquiryForm.get('availability').value?.appointmentStartDate || "";
    const currentDate = DateTime.fromISO(DateTime.now().toString())
      .toFormat(this.dateFormat);
    return this.isValidTestdriveFrom() && apptStartDate >= currentDate
  }

  onSubmit() {
    this.isSubmitting = true;
    if (this.isUpdate) {
      const payload = { appointmentType: AppointmentType.VEHICLE_INQUIRY,settings:this.settings }
      this.salesAppointmentState.dispatch(new fromActions.EditSalesAppointment(payload));
    } else {
      const payload = { appointmentType: AppointmentType.VEHICLE_INQUIRY,settings:this.settings }
      this.salesAppointmentState.dispatch(new fromActions.CreateSalesAppointment(payload));
    }
    this.subscriptions.push(this.salesAppointmentState.select(fromSelectors.editDetails)
      .subscribe((editDetail) => {
        this.onSubmitting(editDetail);
      })
    )
  }

  onSubmitting(data) {
    if (data) {
      if (!data.isSubmitted) {
        this.isSubmitting = false;
      }
      if (data.isSubmitted) {
        this.valueChanged = true;
        const urlState = { ...data.appointmentData };
        const navigationExtras: NavigationExtras = {
          queryParams: {
            id: data.appointmentId
          },
          state: urlState
        };
        this.router.navigate(['asp/bdc/vehicleinquiry/confirm'], navigationExtras);
      }
    }
  }

  onMonthChange($event: DateTime) {
    this.subscriptions.push(this.salesAppointmentState.select(fromSelectors.getAvailabilityDetails)
      .pipe(take(1))
      .subscribe(details => {
        const date = $event.toFormat(this.dateFormat);
        this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
          { selectDateAndSlot: false, date, advisorId: details.advisorId, transport: details.transport, appointmentType: AppointmentType.VEHICLE_INQUIRY,appointmentId:this.appointmentId ? this.appointmentId : ''}));
      }))

  }

  onOtherVehicleChecked() {
    this.otherVehicleChecked = !this.otherVehicleChecked;
    if (this.otherVehiclesArray.length) {
      this.otherVehiclesArray.controls.forEach((a, i) => {
        if (this.otherVehicleChecked) {
          a.setValidators(this.setOtherVehicleValidator());
          a.updateValueAndValidity();
        } else {
          this.removeOtherVehicleValidator(i);
          this.otherVehiclesArray.reset();
        }
      });
    }
  }

  setOtherVehicleValidator(): ValidatorFn {
    return (vehicle: UntypedFormGroup): ValidationErrors => {
      if (this.otherVehicleChecked) {
        this.validatedFields.forEach(fields => {
          if (!vehicle.controls[fields].value) {
            vehicle.controls[fields].setErrors({ required: `${fields} ${this.translateService.instant('service.isRequired')}` });
          }
        });
      }
      return;
    };
  }

  removeOtherVehicleValidator(index: number) {
    const vehicle = this.otherVehiclesArray.controls[index] as UntypedFormGroup;
    this.validatedFields.forEach(field => vehicle.controls[field].setErrors(null, { emitEvent: false }));
    if (index !== 0) {
      this.otherVehiclesArray.removeAt(index);
    }
  }

  backToDashboard() {
    this.router.navigate(['asp/bdc/dashboard']);
  }

  get getDisclaimerText() {
    return this.translateService.instant('testDrive.privacyPolicyTxt');
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.salesAppointmentState.dispatch(new fromActions.ResetSalesAppointmentState());
    this.bannerService.update('');
    this.cd.detach();
  }
  getTranslation(value: any) {
    return value ? this.translateService.instant(`common.${value}`) : value;
  }
}

